import React from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { BAOVECAPVIEN_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import moment from 'moment';

const schema = yup.object().shape({
    ngayBaoVe: yup.string().required('Vui lòng chọn ngày bảo vệ dự kiến')
});

const BaoVeCapVienEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const updateFunc = useMutation((value) => Put(BAOVECAPVIEN_API.UPDATE_ITEM, dataEdit.id, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            Id: dataEdit.id,
            HoSoNghienCuuSinhId: hoSoId,
            NgayBaoVe: values.ngayBaoVe || null,
            TrangThai: dataEdit.trangThai
        };

        updateFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.success)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['baoVeCapVienData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Chỉnh sửa đợt bảo vệ cấp viện</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={{
                        ngayBaoVe: dataEdit?.ngayBaoVe ? moment(dataEdit.ngayBaoVe).format('YYYY-MM-DD') : ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày bảo vệ dự kiến <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayBaoVe"
                                            value={values.ngayBaoVe}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.ngayBaoVe && !!errors.ngayBaoVe && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.ngayBaoVe}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            
                            <div className="text-right mt-3">
                                <Button variant="secondary" onClick={() => setViewMode('list')} className="mr-2" disabled={isSubmitting}>
                                    <i className="fas fa-times mr-1"></i> Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Đang lưu...</> : <><i className="fas fa-save mr-1"></i> Cập nhật</>}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default BaoVeCapVienEdit;
